// Get the current URL and any parameters specified therein
const urlParams = new URLSearchParams(window.location.search)

function insertNavbarUrlsIntoDOM(station) {
  const linkMetadata = {
    'weather-menu1': `https://floridastorms.org/app/feeds/?station=${station}#filter`,
    'weather-menu2': `https://floridastorms.org/app/news/?station=${station}#filter`,
    'weather-mobilemenu1': `https://floridastorms.org/app/feeds/?station=${station}#filter`,
    'weather-mobilemenu2': `https://floridastorms.org/app/news/?station=${station}#filter`
  }

  for (let element in linkMetadata) {
    const elementSelector = document.getElementById(element)
    elementSelector.setAttribute('href', linkMetadata[element])
  }
}

function determineNavbarUrls() {
  if (urlParams.has('station')) {
    const station = urlParams.get('station').toUpperCase()
    insertNavbarUrlsIntoDOM(station)
  } else {
    insertNavbarUrlsIntoDOM('FL')
  }
}

export { determineNavbarUrls }